import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-0 left-0 right-0 bg-white border-t border-primary/10 shadow-[0_-4px_12px_rgba(0,58,93,0.08)] px-4 py-3 flex items-center justify-between z-[9999]",
  style: {"animation":"slideUp 0.3s ease-out"}
}
const _hoisted_2 = { class: "flex items-center flex-1 mr-4 gap-3" }
const _hoisted_3 = { class: "flex-1 text-sm font-medium text-primary" }
const _hoisted_4 = { class: "flex gap-2 shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!

  return (_ctx.showBanner)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.bannerMessage), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "bg-primary text-white text-sm font-medium rounded-md px-4 py-2 cursor-pointer transition-all hover:bg-primary/80 active:scale-95",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBannerClick && _ctx.handleBannerClick(...args)))
            }, _toDisplayString(_ctx.primaryLabel), 1),
            (_ctx.showPwaInstall)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "bg-transparent text-primary border border-primary text-sm font-medium rounded-md px-4 py-2 cursor-pointer transition-all hover:bg-primary/5 active:scale-95",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePwaInstall && _ctx.handlePwaInstall(...args)))
                }, " Add to Home Screen "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("button", {
          class: "flex items-center justify-center w-6 h-6 rounded-full cursor-pointer bg-transparent border-none ml-1 hover:bg-primary/5 shrink-0",
          "aria-label": "Close",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dismissBanner && _ctx.dismissBanner(...args)))
        }, [
          _createVNode(_component_XMarkIcon, { class: "w-3.5 h-3.5 text-gray-500" })
        ])
      ]))
    : _createCommentVNode("", true)
}